/* eslint-disable */
/* eslint-disable no-restricted-syntax */

// react imports
import React, { useState, useEffect } from "react";

// @mui material components
import { Divider, Radio } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// notistack imports
import { useSnackbar } from "notistack";

import { Select } from '@mui/material';
// import NativeSelect from "@mui/material/NativeSelect";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

// Material Dashboard 2 React context
import { useMaterialUIController, setChosenAddress, setFinalAddress, setPageState } from "context";

// Firebase imports
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { db } from "../../../../../../Firebase";
import { position } from "stylis";

function CheckoutAddress() {
  const [controller, dispatch] = useMaterialUIController();
  const { cart, chosenAddress, editOrder } = controller;
  const { enqueueSnackbar } = useSnackbar();

  const [addresses, setAddresses] = useState([]);
  const [country, setCountry] = useState(chosenAddress.country);
  const [countryError, setCountryError] = useState(false);
  const [isInternational, setIsInternational] = useState(chosenAddress.country !== "United States");
  const [email, setEmail] = useState(chosenAddress.email);
  const [emailError, setEmailError] = useState(false);
  const [phone, setPhone] = useState(chosenAddress.phone);
  const [phoneError, setPhoneError] = useState(false);
  const [attn, setAttn] = useState(chosenAddress.attn);
  const [attnError, setAttnError] = useState(false);
  const [clinic, setClinic] = useState(chosenAddress.clinic);
  const [clinicError, setClinicError] = useState(false);
  const [addressLine1, setAddressLine1] = useState(chosenAddress.addressLine1);
  const [addressLine1Error, setAddressLine1Error] = useState(false);
  const [addressLine2, setAddressLine2] = useState(chosenAddress.addressLine2);
  // const [addressLine2Error, setAddressLine2Error] = useState(false);
  const [addressLine3, setAddressLine3] = useState(chosenAddress.addressLine3);
  // const [addressLine3Error, setAddressLine3Error] = useState(false);
  const [city, setCity] = useState(chosenAddress.city);
  const [cityError, setCityError] = useState(false);
  const [state, setState] = useState(chosenAddress.state);
  const [stateError, setStateError] = useState(false);
  const [zip, setZip] = useState(chosenAddress.zip);
  const [zipError, setZipError] = useState(false);
  const [cartError, setCartError] = useState(false);

  const [shippingSaved, setShippingSaved] = useState(false);

  const auth = getAuth();
  const userInfo = auth.currentUser;
  const [user] = useAuthState(auth);

  const AddressSelect = () => {

    const [selectedAddress, setSelectedAddress] = useState('');
    const handleChange = (event) => {
      const selected = addresses.find(addr => addr.id === event.target.value);
      setSelectedAddress(event.target.value);
      
      setCountry(selected.country);
      setIsInternational(selected.isInternational);
      setEmail(selected.email);
      setPhone(selected.phone);
      setAttn(selected.attn);
      setClinic(selected.clinic);
      setAddressLine1(selected.addressLine1);
      setAddressLine2(selected.addressLine2);
      setAddressLine3(selected.addressLine3);
      setCity(selected.city);
      setState(selected.state);
      setZip(selected.zip);

      setChosenAddress(dispatch, {
        nickName: selected.nickName,
        attn: selected.attn,
        clinic: selected.clinic,
        addressLine1: selected.addressLine1,
        addressLine2: selected.addressLine2,
        addressLine3: selected.addressLine3,
        city: selected.city,
        state: selected.state,
        zip: selected.zip,
        country: selected.country,
      });

    };

    const formatAddress = (address) => {
      return (
        <MDBox sx={{ whiteSpace: 'pre-line', py: 1, px: 4 }}>
          <MDTypography variant="caption">
            <b>{address.email}</b>
            <br />
            {address.phone}
            <br />
            Attn: {address.attn}
            <br />
            {address.addressLine1}
            <br />
            {address.addressLine2 && address.addressLine2.length > 0 && (
              <>
                {address.addressline2} <br />
              </>
            )}
            {address.addressline3 && address.addressline3.length > 0 && (
              <>
                {address.addressline3} <br />
              </>
            )}
            {address.city}, {address.state}
            {" "}
            {address.zip}
            <br />
            {address.country}
          </MDTypography>
        </MDBox>
      );
    };

    return (
      <FormControl fullWidth>
        <Select
          value={selectedAddress}
          onChange={handleChange}
          displayEmpty
          renderValue={(value) => {
            if (!value) {
              return <>
                <MDBox sx={{ position: 'relative', width: '100%', padding: '8px 4px' }}>
                  <MDTypography variant="p" color="text.secondary" sx={{ padding: '8px 4px' }}>Select an address</MDTypography>
                  <MDBox sx={{ position: 'absolute', top: '40%', right: 0, transform: 'scaleY(50%) translateY(-50%)', paddingRight: '5px' }}>▼</MDBox>
                </MDBox>
              </>;
            }
            const address = addresses.find(addr => addr.id === value);
            return formatAddress(address);
          }}
        >
          {addresses.map((address) => (
            <MenuItem key={address.id} value={address.id}>
              {formatAddress(address)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  useEffect(() => {
    (async () => {
    const userForAddressBook = userInfo.uid;
    const colRef = await getDocs(collection(db, "USERS", userForAddressBook, "ADDRESSES"));
    const addressArray = colRef.docs.map((el) => ({ ...el.data(), id: el.id }));

    // Pre-populate with last saved address
    if (addressArray.length > 0){
      setAddresses(addressArray);
      const firstAddress = addressArray[0];
      setCountry(firstAddress.country);
      setIsInternational(firstAddress.isInternational);
      setEmail(firstAddress.email);
      setPhone(firstAddress.phone);
      setAttn(firstAddress.attn);
      setClinic(firstAddress.clinic);
      setAddressLine1(firstAddress.addressLine1);
      setAddressLine2(firstAddress.addressLine2);
      setAddressLine3(firstAddress.addressLine3);
      setCity(firstAddress.city);
      setState(firstAddress.state);
      setZip(firstAddress.zip);

      setChosenAddress(dispatch, {
        nickName: firstAddress.nickName,
        attn: firstAddress.attn,
        clinic: firstAddress.clinic,
        addressLine1: firstAddress.addressLine1,
        addressLine2: firstAddress.addressLine2,
        addressLine3: firstAddress.addressLine3,
        city: firstAddress.city,
        state: firstAddress.state,
        zip: firstAddress.zip,
        country: firstAddress.country,
      });
    }

    })();
  }, []);

  const checkShipping = async (el) => {
    console.log(el);

    if (country === undefined) {
      return;
    }

    if (attn === "") {
      setAttnError(true);
    }

    if (email === "") {
      setEmailError(true);
    }

    if (phone === "") {
      setPhoneError(true);
    }

    if (clinic === "") {
      setClinicError(true);
    }

    if (addressLine1 === "") {
      setAddressLine1Error(true);
    }

    if (city === "") {
      setCityError(true);
    }

    if (state === "") {
      setStateError(true);
    }

    if (zip === "") {
      setZipError(true);
    }

    if (country === "") {
      setCountryError(true);
    }

    if (cart.length === 0) {
      setCartError(true);
    }

    if (addressLine1 && city && zip && cart.length !== 0) {
      // const today = new Date();
      // const orderID = uuid();

      const itemsArray = [];
      cart.map((object) =>
        itemsArray.push({
          image: object.image,
          title: object.title,
          quantity: object.cartQuantity || 0,
          language: object.language,
          customized: object.isCustomized,
        })
      );

      const shippingAddress = {
        email: el.email,
        phone: el.phone,
        attn: el.attn,
        country: el.country,
        clinic: el.clinic,
        addressLine1: el.addressLine1,
        addressLine2: el.addressLine2,
        addressLine3: el.addressLine3,
        city: el.city,
        state: el.state,
        zip: el.zip,
      };

      setFinalAddress(dispatch, shippingAddress);
      window.localStorage.setItem("chosenAddress", JSON.stringify(shippingAddress));

      const variant = "success";
      enqueueSnackbar("Shipping address added to order!", {
        variant,
        autoHideDuration: 2000,
      });
      setShippingSaved(true);
    } else {
      console.log("fill in that info!");
    }
  };

  return (
    <MDBox p={2}>
      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
        Saved addresses
      </MDTypography>
      <MDBox p={2}>
        <AddressSelect />
      </MDBox>
      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
        shipping info
      </MDTypography>
      <MDBox p={2}>
        {attnError && (
          <MDTypography variant="caption" color="error">
            Please enter an ATTN to.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Attention to"
          value={attn}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAttn(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {emailError && (
          <MDTypography variant="caption" color="error">
            Please enter an email address.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Email"
          value={email || ""}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {phoneError && (
          <MDTypography variant="caption" color="error">
            Please enter a phone number.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Phone #"
          value={phone || ""}
          onChange={(e) => {
            setPhone(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        <MDTypography variant="caption">Select Country:</MDTypography>
        <Radio
          checked={country === "United States"}
          onChange={(e) => {
            setCountry(e.target.value);
            setCountryError(false);
            setIsInternational(false);
          }}
          value="United States"
          name="radio-buttons"
          inputProps={{ "aria-label": "United States" }}
        />
        <MDTypography variant="caption">United States</MDTypography>
        <Radio
          checked={country !== "United States"}
          onChange={() => {
            setCountry("");
            setIsInternational(true);
          }}
          value="International"
          name="radio-buttons"
          inputProps={{ "aria-label": "International" }}
        />
        <MDTypography variant="caption">International</MDTypography>
      </MDBox>
      <MDBox p={2}>
        {countryError && (
          <MDTypography variant="caption" color="error">
            Please enter a Country.
          </MDTypography>
        )}
        {isInternational && (
          <MDInput
            type="text"
            label="Country Name"
            value={country}
            inputProps={{ maxLength: 35 }}
            onChange={(e) => {
              setCountry(e.target.value);
            }}
            style={{ width: "100%" }}
          />
        )}
      </MDBox>
      <MDBox p={2}>
        {clinicError && (
          <MDTypography variant="caption" color="error">
            Please enter a clinic name.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Clinic Name"
          value={clinic || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setClinic(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {addressLine1Error && (
          <MDTypography variant="caption" color="error">
            Please enter an address.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Address Line 1"
          value={addressLine1 || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine1(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {/* {addressLine2Error && (
              <MDTypography variant="caption" color="error">
                Please enter an address.
              </MDTypography>
            )} */}
        <MDInput
          type="text"
          label="Address Line 2"
          value={addressLine2 || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine2(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {/* {addressLine3Error && (
              <MDTypography variant="caption" color="error">
                Please enter an address.
              </MDTypography>
            )} */}
        <MDInput
          type="text"
          label="Address Line 3"
          value={addressLine3 || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine3(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {cityError && (
          <MDTypography variant="caption" color="error">
            Please enter a city.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="City"
          value={city || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setCity(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {stateError && (
          <MDTypography variant="caption" color="error">
            Please enter a State/Province.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="State/Province"
          value={state || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setState(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {zipError && (
          <MDTypography variant="caption" color="error">
            Please enter a postal code.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Postal Code"
          value={zip || ""}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setZip(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox px={3} pt={1}>
        {cartError && (
          <MDTypography variant="caption" color="error">
            Your cart is empty!
          </MDTypography>
        )}
      </MDBox>
      <Divider />
      {shippingSaved ? (
        <MDBox p={3}>
          <MDButton
            color="success"
            onClick={() => {
              setPageState(dispatch, "Review");
            }}
            fullWidth
          >
            Review Order
          </MDButton>
        </MDBox>
      ) : (
        <MDBox p={3}>
          <MDButton
            variant="outlined"
            color="info"
            onClick={() => {
              checkShipping({
                attn,
                email,
                phone,
                clinic,
                addressLine1,
                addressLine2,
                addressLine3,
                city,
                state,
                zip,
                country,
              });
            }}
            fullWidth
          >
            Save Shipping Address To Order
          </MDButton>
        </MDBox>
      )}
      {editOrder && (
        <MDBox px={3} py={1}>
          <MDButton
            color="dark"
            onClick={() => {
              setPageState(dispatch, "Review");
            }}
            fullWidth
          >
            return to order review
          </MDButton>
        </MDBox>
      )}
    </MDBox>
  );
}

export default CheckoutAddress;
